import { useQuery } from '@tanstack/react-query';

import { TwilioTokenType } from '../../services/Twilio/types';
import query from '../../constants/queries';
import { request } from './request';

const useGetTwilioToken = () =>
    useQuery([query.tokenTwilio], async () => await request<TwilioTokenType>('get', 'twilio/token'));

export default useGetTwilioToken;
